import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _class2, _descriptor, _descriptor2, _availableTips, _renderedId, _shouldRenderSet, _UserTips_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import Service, { service } from "@ember/service";
import { TrackedSet } from "@ember-compat/tracked-built-ins";
import { disableImplicitInjections } from "discourse/lib/implicit-injections";
import { isTesting } from "discourse-common/config/environment";
let UserTips = disableImplicitInjections(_class = (_class2 = (_availableTips = /*#__PURE__*/new WeakMap(), _renderedId = /*#__PURE__*/new WeakMap(), _shouldRenderSet = /*#__PURE__*/new WeakMap(), _UserTips_brand = /*#__PURE__*/new WeakSet(), class UserTips extends Service {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _UserTips_brand);
    _initializerDefineProperty(this, "site", _descriptor, this);
    _initializerDefineProperty(this, "currentUser", _descriptor2, this);
    _classPrivateFieldInitSpec(this, _availableTips, new Set());
    _classPrivateFieldInitSpec(this, _renderedId, void 0);
    _classPrivateFieldInitSpec(this, _shouldRenderSet, new TrackedSet());
  }
  shouldRender(id) {
    return _classPrivateFieldGet(_shouldRenderSet, this).has(id);
  }
  addAvailableTip(tip) {
    if (this.canSeeUserTip(tip.id) && !this._findAvailableTipById(tip.id)) {
      _classPrivateFieldGet(_availableTips, this).add(tip);
      _assertClassBrand(_UserTips_brand, this, _updateRenderedId).call(this);
    }
  }
  removeAvailableTip(tip) {
    _classPrivateFieldGet(_availableTips, this).delete(tip);
    _assertClassBrand(_UserTips_brand, this, _updateRenderedId).call(this);
  }
  canSeeUserTip(tipId) {
    if (!this.currentUser) {
      return false;
    }
    const userTips = this.site.user_tips;
    if (!userTips || this.currentUser.user_option?.skip_new_user_tips) {
      return false;
    }
    if (!userTips[tipId]) {
      if (!isTesting()) {
        // eslint-disable-next-line no-console
        console.warn("Cannot show user tip with id", tipId);
      }
      return false;
    }
    const seenUserTips = this.currentUser.user_option?.seen_popups || [];
    if (seenUserTips.includes(-1) || seenUserTips.includes(userTips[tipId])) {
      return false;
    }
    return true;
  }
  async hideUserTipForever(tipId) {
    if (!this.currentUser) {
      return;
    }
    const userTips = this.site.user_tips;
    if (!userTips || this.currentUser.user_option?.skip_new_user_tips) {
      return;
    }
    if (!userTips[tipId]) {
      // eslint-disable-next-line no-console
      console.warn("Cannot hide user tip with id", tipId);
      return;
    }
    const tipObj = [..._classPrivateFieldGet(_availableTips, this)].find(t => t.id === tipId);
    this.removeAvailableTip(tipObj);
    await this.markAsSeen(tipId);
  }
  async markAsSeen(tipId) {
    if (!this.currentUser) {
      return;
    }
    if (!tipId) {
      return;
    }
    const userTips = this.site.user_tips;
    if (!userTips || this.currentUser.user_option?.skip_new_user_tips) {
      return;
    }

    // Update list of seen user tips.
    let seenUserTips = this.currentUser.user_option?.seen_popups || [];
    if (seenUserTips.includes(userTips[tipId])) {
      return;
    }
    seenUserTips.push(userTips[tipId]);

    // Save seen user tips on the server.
    if (!this.currentUser.user_option) {
      this.currentUser.set("user_option", {});
    }
    this.currentUser.set("user_option.seen_popups", seenUserTips);
    await this.currentUser.save(["seen_popups"]);
  }
  async skipTips() {
    if (!this.currentUser) {
      return;
    }
    _classPrivateFieldGet(_availableTips, this).clear();
    _classPrivateFieldGet(_shouldRenderSet, this).clear();
    this.currentUser.set("user_option.skip_new_user_tips", true);
    await this.currentUser.save(["skip_new_user_tips"]);
  }
  _findAvailableTipById(id) {
    for (let item of _classPrivateFieldGet(_availableTips, this)) {
      if (item.id === id) {
        return item;
      }
    }
    return null;
  }
}), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class;
function _updateRenderedId() {
  const tipsArray = [..._classPrivateFieldGet(_availableTips, this)];
  if (tipsArray.find(tip => tip.id === _classPrivateFieldGet(_renderedId, this))) {
    return;
  }
  const newId = tipsArray.sortBy("priority").reverse().find(tip => {
    if (this.canSeeUserTip(tip.id)) {
      return tip.id;
    }
  })?.id;
  if (_classPrivateFieldGet(_renderedId, this) !== newId) {
    _classPrivateFieldGet(_shouldRenderSet, this).delete(_classPrivateFieldGet(_renderedId, this));
    _classPrivateFieldGet(_shouldRenderSet, this).add(newId);
    _classPrivateFieldSet(_renderedId, this, newId);
  }
}
export { UserTips as default };